

























































































import { ref, PropType, defineComponent, watch } from '@vue/composition-api';
import { DirectiveOptions } from 'vue';

import { IWorkflowFormSubmissionCommentAttachment } from '@/models';
import { fileToDataUrl } from '@/utils/fileUtils';
import { vResizeObserver } from '@vueuse/components';
import { humanReadableFileSize } from '@/utils/helpers';

export default defineComponent({
  name: 'WorkflowFormSubmissionCommentAttachmentList',

  directives: {
    ResizeObserver: vResizeObserver as DirectiveOptions
  },

  props: {
    attachments: {
      type: Array as PropType<IWorkflowFormSubmissionCommentAttachment[]>,
      defaults: () => [],
      required: false
    }
  },

  setup(props, { emit, root }) {
    type FileData = {
      type: 'image' | 'text' | 'other';
      fileUrl: string;
      fileName: string;
      fileSize: number;
    };

    type AttachmentFileData = {
      attachment: IWorkflowFormSubmissionCommentAttachment;
    } & FileData;

    const attachmentFileDataList = ref<AttachmentFileData[]>([]);

    watch(
      () => props.attachments,
      async value => {
        if (!value) return;

        let list = [];
        for (let index = 0; index < value.length; index++) {
          const attachment = value[index];

          const fileData = await loadFileContentFromAttachment(attachment);

          list.push({
            attachment: attachment,
            type: fileData.type,
            fileUrl: fileData.fileUrl,
            fileName: fileData.fileName,
            fileSize: fileData.fileSize
          });
        }

        attachmentFileDataList.value = list;
      },
      {
        deep: true,
        immediate: true
      }
    );

    function removeAttachment(index: number) {
      emit('remove-attachment', index);
    }

    function loadAttachmentFile(attachment: string) {
      return root.$services.fileLoader.downloadFile(attachment);
    }

    async function loadFileContentFromAttachment(
      attachment: IWorkflowFormSubmissionCommentAttachment
    ): Promise<FileData> {
      let attachmentFile = attachment.file;

      let fileName = '';

      if (typeof attachmentFile === 'string') {
        fileName = attachment.filename;
        const blob = await loadAttachmentFile(attachmentFile);
        attachmentFile = new File([blob], fileName, { type: blob.type });
      }

      fileName = attachmentFile.name;

      let fileType: FileData['type'] = 'other';
      let fileUrl = URL.createObjectURL(attachmentFile);

      if (attachmentFile.type.startsWith('image/')) {
        fileType = 'image';
        fileUrl = await fileToDataUrl(attachmentFile);
      }

      return {
        type: fileType,
        fileUrl: fileUrl,
        fileSize: attachmentFile.size,
        fileName: fileName
      };
    }

    const contentWidth = ref(0);

    function onResizeObserver(entries: ReadonlyArray<ResizeObserverEntry>) {
      const [entry] = entries;
      const { width } = entry.contentRect;
      contentWidth.value = width ?? 500;
    }

    return {
      contentWidth,
      attachmentFileDataList,
      removeAttachment,
      onResizeObserver,
      humanReadableFileSize
    };
  }
});
